import React from 'react'
import classes from 'classnames'
import Loader from './Loader'

export default ({ onClick, loading = false, children }) => (
  <button className={classes('Button Button_black', { 'Button_loading': loading })} onClick={onClick}>
    {children}
    {loading && (
      <div className='Button__loader'>
        <Loader />
      </div>
    )}
  </button>
)



// WEBPACK FOOTER //
// ./src/components/Button.jsx